<template>
  <div class="q-pa-md">
    <div class="column q-col-gutter-md">
      <div class="col">
        <q-input
          v-model="payments.paypal"
          outlined
          clearable
          label="PayPal"
          bg-color="white"
        >
          <template v-slot:before>
            <q-avatar>
              <img src="../../assets/images/paypal.png" />
            </q-avatar>
          </template>
        </q-input>
      </div>
      <div class="col">
        <q-input
          v-model="payments.visa"
          outlined
          clearable
          label="Cartão de Crédito"
          bg-color="white"
        >
          <template v-slot:before>
            <q-avatar>
              <img src="../../assets/images/visa.png" />
            </q-avatar>
          </template>
        </q-input>
      </div>
      <div class="col row justify-between">
        <a href="#" class="text-link q-ml-xl">
          <q-icon class="q-mr-xs q-mb-xs" name="add" size="20px"></q-icon>
          Adicionar Meio de Pagamento
        </a>
        <q-btn class="q-ml-md" color="secondary" label="Guardar" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'PaymentMethods',

    components: {},

    data () {
        return {
            payments: {
                paypal: 'jfna@gmail.com',
                visa: '**** **** **** 4056',
            },
        }
    },
}
</script>
